import { useMutation, useQueryClient } from "react-query";
import { useUser } from "@/providers/context";
import { AxiosError } from "axios";
import {
  NotificationPreferenceResponse,
  updateNotificationPreferences,
} from "@/api";

export const useUpdateNotificationPreferences = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    NotificationPreferenceResponse | undefined,
    AxiosError<{ error: string }>,
    Partial<NotificationPreferenceResponse>
  >(
    async (payload) => {
      if (uid) {
        return await updateNotificationPreferences({ user_id: uid, payload });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["notificationPreferences", uid], data);
        }
      },
    },
  );
};
